<div class="tcd-container" [class.tcd-container-sub]="currentSubContext">
  <div class="tcd-header">
    <div class="tcd-header-title">
      <div class="tcd-title-row">
        <button
          type="button"
          mat-button
          class="tcd-back-button"
          *ngIf="currentSubContext"
          (click)="goBackClicked()"
        >
          <mat-icon>arrow_back</mat-icon> Back
        </button>
        <h2>{{ currentSubContext ? 'Configure Object Fields' : 'Configure Validation Template' }}</h2>
      </div>
      <p class="tcd-header-subtitle" *ngIf="currentSubContext">
        Applied to every object in <span class="tcd-path-chip">{{ fullSubPath }}</span> --
        checks defined here run once per index in that range.
      </p>
    </div>
    <div class="tcd-tabs">
      <button mat-button [class.active]="viewMode === 'json'" (click)="switchToJson()">
        <mat-icon>code</mat-icon> <span>JSON</span>
      </button>
      <button mat-button [class.active]="viewMode === 'table'" (click)="switchToTable()">
        <mat-icon>table_rows</mat-icon> <span>Table</span>
      </button>
    </div>
  </div>

  <div mat-dialog-content class="tcd-content">
    <!-- JSON view -->
    <div *ngIf="viewMode === 'json'" class="tcd-json-view">
      <textarea
        class="tcd-json-textarea"
        [(ngModel)]="jsonText"
        spellcheck="false"
      ></textarea>
      <p class="tcd-error" *ngIf="jsonError">{{ jsonError }}</p>
    </div>

    <!-- Table view -->
    <div *ngIf="viewMode === 'table'" class="tcd-table-view">
      <div class="tcd-table-header">
        <span class="tcd-col-path">Field path</span>
        <span class="tcd-col-rule">Check</span>
        <span class="tcd-col-param">Value / parameter</span>
        <span class="tcd-col-severity">Assertion type</span>
      </div>
      <div class="tcd-group" *ngFor="let group of groups; trackBy: trackByGroup">
        <ng-container *ngFor="let row of group.rows; let i = index">
        <div class="tcd-row">
          <input
            *ngIf="i === 0; else pathBlank"
            class="tcd-path-input"
            [ngModel]="group.rows[0].path"
            (ngModelChange)="onGroupPathChange(group, $event)"
            [placeholder]="group.rows[0].ruleType === 'array_object' ? 'leave blank if the whole response IS this array' : 'e.g. dob.age or results[0].email'"
          />
          <ng-template #pathBlank><span class="tcd-path-blank"></span></ng-template>

          <select class="tcd-rule-select" [(ngModel)]="row.ruleType">
            <option *ngFor="let rt of ruleTypes" [value]="rt.value">{{ rt.label }}</option>
          </select>

          <ng-container [ngSwitch]="row.ruleType">
            <span *ngSwitchCase="'not_null'" class="tcd-param-disabled">—</span>
            <span *ngSwitchCase="'not_empty'" class="tcd-param-disabled">—</span>
            <span *ngSwitchCase="'no_special_chars'" class="tcd-param-disabled">—</span>
            <input
              *ngSwitchCase="'contains'"
              class="tcd-param-input"
              [(ngModel)]="row.param"
              placeholder="substring or array element"
            />
            <input
              *ngSwitchCase="'variable'"
              class="tcd-param-input"
              [(ngModel)]="row.param"
              placeholder="variableName (no ##)"
            />
            <select
              *ngSwitchCase="'type'"
              class="tcd-rule-select"
              [(ngModel)]="row.param"
            >
              <option *ngFor="let dt of dataTypes" [value]="dt">{{ dt }}</option>
            </select>
            <div *ngSwitchCase="'numeric'" class="tcd-numeric-group">
              <select class="tcd-operator-select" [(ngModel)]="row.operator">
                <option *ngFor="let op of numericOperators" [value]="op">{{ op }}</option>
              </select>
              <input class="tcd-param-input" [(ngModel)]="row.param" placeholder="e.g. 0" />
            </div>
            <div *ngSwitchCase="'array_size'" class="tcd-numeric-group">
              <select class="tcd-operator-select" [(ngModel)]="row.operator">
                <option *ngFor="let op of sizeLengthOperators" [value]="op">{{ op }}</option>
              </select>
              <input class="tcd-param-input" [(ngModel)]="row.param" placeholder="e.g. 0" />
            </div>
            <div *ngSwitchCase="'length'" class="tcd-numeric-group">
              <select class="tcd-operator-select" [(ngModel)]="row.operator">
                <option *ngFor="let op of sizeLengthOperators" [value]="op">{{ op }}</option>
              </select>
              <input class="tcd-param-input" [(ngModel)]="row.param" placeholder="e.g. 8" />
            </div>
            <div *ngSwitchCase="'array_object'" class="tcd-loop-group">
              <input
                class="tcd-loop-index"
                type="number"
                [ngModel]="loopStartDisplay(row)"
                (ngModelChange)="onLoopStartDisplayChange(row, $event)"
                placeholder="1"
                title="Leave blank to start from the first element"
                min="1"
                [class.tcd-input-error]="loopRangeInvalid(row)"
              />
              <span class="tcd-loop-sep">–</span>
              <input
                class="tcd-loop-index"
                type="number"
                [ngModel]="loopEndDisplay(row)"
                (ngModelChange)="onLoopEndDisplayChange(row, $event)"
                placeholder="{{ maxLoopRange }}"
                title="Leave blank to check up to the first 100 elements"
                min="1"
                [class.tcd-input-error]="loopRangeInvalid(row)"
              />
              <button
                mat-icon-button
                class="tcd-loop-configure"
                (click)="configureSubTemplate(row)"
                aria-label="Configure object fields"
                title="Configure the fields to check on each object in this range"
              >
                <mat-icon>settings</mat-icon>
              </button>
              <span class="tcd-loop-hint">max {{ maxLoopRange }}</span>
            </div>
            <input
              *ngSwitchDefault
              class="tcd-param-input"
              [(ngModel)]="row.param"
              placeholder="expected value"
            />
          </ng-container>

          <select
            class="tcd-severity-select"
            [ngModel]="row.severity"
            (ngModelChange)="onSeverityChange(row, $event)"
            title="Assert: a failure stops the scenario. Verify: a failure is reported but doesn't stop it. Ignore: this check is skipped entirely. For an Array object check, this is also the default Assertion type its own fields get."
          >
            <option *ngFor="let sev of severities" [value]="sev.value">{{ sev.label }}</option>
          </select>

          <button mat-icon-button class="tcd-remove-check" (click)="removeCheck(row)" aria-label="Remove this check">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <!-- Read-only preview of this array-object loop check's sub-template,
             directly under its own row, so what's configured is visible on
             the main screen without reopening the nested dialog. -->
        <div class="tcd-row tcd-loop-summary-row" *ngIf="row.ruleType === 'array_object'">
          <span class="tcd-path-blank"></span>
          <div class="tcd-loop-summary-panel">
            <ng-container *ngIf="getSubTemplateSummary(row) as fieldGroups">
              <div class="tcd-loop-summary-table" *ngIf="fieldGroups.length > 0">
                <div class="tcd-loop-summary-header-row">
                  <span>Field</span><span>Check</span><span>Value</span>
                </div>
                <div class="tcd-loop-summary-field-group" *ngFor="let fg of fieldGroups">
                  <div class="tcd-loop-summary-entry-row" *ngFor="let e of fg.entries; let ei = index">
                    <span class="tcd-loop-summary-path">{{ ei === 0 ? fg.path : '' }}</span>
                    <span>{{ e.ruleLabel }}<em *ngIf="e.severity === 'verify'"> (verify)</em></span>
                    <span>{{ e.detail }}</span>
                  </div>
                </div>
              </div>
              <span class="tcd-loop-summary-empty" *ngIf="fieldGroups.length === 0">No object fields configured yet</span>
            </ng-container>
          </div>
        </div>
        </ng-container>

        <div class="tcd-row tcd-add-check-row">
          <span class="tcd-path-blank"></span>
          <button mat-button class="tcd-add-check" (click)="addCheckToGroup(group)">
            <mat-icon>add</mat-icon> <span>Add check</span>
          </button>
        </div>
      </div>

      <button mat-button class="tcd-add-row" (click)="addRow()">
        <mat-icon>add</mat-icon> <span>Add field</span>
      </button>
      <p class="tcd-error" *ngIf="jsonError">{{ jsonError }}</p>
    </div>
  </div>

  <div mat-dialog-actions class="tcd-actions">
    <button mat-button (click)="cancel()">
      <mat-icon>close</mat-icon> <span>Cancel</span>
    </button>
    <button mat-raised-button color="primary" (click)="save()">
      <mat-icon>check</mat-icon> <span>{{ currentSubContext ? 'Apply & Back' : 'Save' }}</span>
    </button>
  </div>
</div>
